import { render, staticRenderFns } from "./add-queue.vue?vue&type=template&id=55b966fe&scoped=true&"
import script from "./add-queue.vue?vue&type=script&lang=js&"
export * from "./add-queue.vue?vue&type=script&lang=js&"
import style0 from "./add-queue.vue?vue&type=style&index=0&id=55b966fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b966fe",
  null
  
)

export default component.exports